import { createSlice } from "@reduxjs/toolkit";

export const activityConfigSlice = createSlice({
    name: 'activityConfig',
    initialState: {
        value: undefined
    },
    reducers: {
        setActivityConfig: (state, action) => {
            state.value = action.payload;
        }
    }
})

export const { setActivityConfig } = activityConfigSlice.actions;

export const getActivityConfig = (state) => state.activityConfig.value;

export default activityConfigSlice.reducer;